import React from 'react';
import { string, number } from 'prop-types';

import * as helpers from './helpers';
import { theme } from '../../../styles';

const LabelIcon = ({ color, fillOpacity, ...props }) => (
  <svg
    {...helpers.getSvgDimensionsProps(props)}
    {...helpers.getViewBoxProperty(props)}
    {...props}
    fill={color}
  >
    <path
      fill={color}
      stroke={color}
      strokeWidth=".5"
      d="M11.708 3H7.154a.352.352 0 0 0-.248.103L1.378 8.631a1.293 1.293 0 0 0 0 1.826l4.164 4.165c.244.243.568.377.914.377.346 0 .67-.134.913-.377l5.528-5.528A.352.352 0 0 0 13 8.846V4.292C13 3.579 12.42 3 11.708 3zm.589 5.7l-5.425 5.425a.584.584 0 0 1-.416.171.584.584 0 0 1-.416-.171L1.875 9.96a.59.59 0 0 1 0-.832L7.3 3.703h4.408a.59.59 0 0 1 .589.589V8.7z"
    />
    <path
      fill={color}
      d="M9 5c-.534 0-1.036.208-1.414.586C7.208 5.964 7 6.466 7 7c0 .534.208 1.036.586 1.414C7.964 8.792 8.466 9 9 9c.534 0 1.036-.208 1.414-.586.378-.378.586-.88.586-1.414 0-.534-.208-1.036-.586-1.414A1.987 1.987 0 0 0 9 5zm.514 2.514A.722.722 0 0 1 9 7.727a.722.722 0 0 1-.514-.213A.722.722 0 0 1 8.273 7c0-.194.076-.377.213-.514A.722.722 0 0 1 9 6.273c.194 0 .377.076.514.213a.722.722 0 0 1 0 1.028z"
    />
    <path
      d="M10 6l5-5"
      stroke={color}
      strokeWidth="1.3"
      strokeLinecap="round"
    />
  </svg>
);

LabelIcon.propTypes = {
  fillOpacity: number,
  color: string.isRequired,
  ...helpers.iconDimensionsPropTypes,
};

LabelIcon.defaultProps = {
  fillOpacity: 0.4,
  color: theme.colors.backgroundDarkGray,
  ...helpers.getDefaultIconDimensionsProps(17, 16),
};

export default LabelIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/label.js